<template>

	<div>

		<div v-if="imageUrl || value" class="image-panel" :class="{'expand-on-click':expandOnClick}" ref="imageContainer">

			<input v-if="selectable" type="checkbox" class="select-checkbox" v-model="selected">

			<div v-if="!readonly && !isPdf" class="banner banner-top">

				<template v-if="!readonly">
					<!--<button v-on:click="rotateImage('left')" type="button" class="btn btn-light">
						<i class="fa fa-rotate-left"></i>
					</button>
					<button v-on:click="rotateImage('right')" type="button" class="btn btn-light">
						<i class="fa fa-rotate-right"></i>
					</button>
					<button v-if="!noDelete" v-on:click="deleteImg" type="button" class="btn btn-outline-danger">
						<i class="fa fa-trash"></i>
					</button>-->
					<a v-if="downloadUrl" :href="downloadUrl" download><i class="fas fa-download text-white ml-3 icon-button" ></i></a>
					<i v-if="!noEdit"   class="fas fa-pen icon-button text-white ml-3" v-on:click="editingVisible = true"></i>
					<i v-if="!noRotate" class="fas fa-undo icon-button text-white ml-3" v-on:click="rotateImage('left')"></i>
					<i v-if="!noRotate" class="fas fa-undo fa-flip-horizontal icon-button text-white ml-3" v-on:click="rotateImage('right')"></i>
					<i v-if="!noDelete" class="fa fa-trash icon-button ml-3" style="color:#ff3c3c" v-on:click="deleteImg"></i>
				</template>
			</div>


			<div v-if="showUser" class="banner banner-bottom">
				Uploaded
				<span v-if="uploadedBy"> by {{uploadedBy}}</span>
				<span v-if="uploadedBy && uploadedAt"><br></span>
				<span v-if="uploadedAt"> on {{uploadedAt}}</span>
			</div>


			<image-with-layers
				v-if="!isPdf"
				:image="value"
				:image-url="imageUrl"
				:layers="layers"
				:width="canvasWidth"
				:height="canvasHeight"
				v-on:click="imageClicked">
			</image-with-layers>

			<div v-else-if="isPdf" class="pdf-container" :style="{maxHeight,maxWidth}">
				<div class="pdf-btn-container">
					<i class="fa fa-expand text-white icon-button ml-2" v-on:click="imageClicked"></i>
					<template v-if="!readonly">
						<i v-if="!noDelete" class="fa fa-trash icon-button ml-2" style="color:#ff3c3c" v-on:click="deleteImg"></i>
					</template>
				</div>
				<iframe
					scrolling="no"

					seamless="seamless"
					style="overflow: hidden;"
					:src="imageUrl">
				</iframe>
			</div>

			<image-viewer
				v-if="viewerVisible"
				:force-pdf="forcePdf ? true : false"
				:url="localExpandUrl"
				:layers="layers"
				v-on:close="viewerVisible = false">
			</image-viewer>
		</div>
		<div v-else class="img-thumbnail">
			<i class="fa fa-5x" :class="icon"></i>
		</div>

		<edit-image-modal
			v-if="!isPdf"
			:modal-visible="editingVisible"
			:image-url="localExpandUrl"
			:layers="layers"
			v-on:deleteLayer="deleteLayer"
			v-on:saveLayer="saveLayer"
			v-on:closeModal="editingVisible = false">
		</edit-image-modal>

	</div>

</template>

<script type="text/javascript">
import ImageViewer from "./ImageViewer"
import EditImageModal from "@/components/super_components/EditImageModal";
import ImageWithLayers from "@/components/ImageWithLayers";

export default {
	name: "ImagePanel",
	props: [
		"readonly",
		"imageUrl",
		"expandUrl",
		"icon",
		"expandOnClick",
		"selectable",
		"value",
		"maxHeight",
		"maxWidth",
		"noDelete",
		"forcePdf",
		"noEdit",
		"noRotate",
		"showUser"
	],
	components: {
		ImageViewer,
		EditImageModal,
		ImageWithLayers
	},
	data() {
		return {
			viewerVisible: false,
			selected: this.value,
			editingVisible: false,
			layers: null,				// Fetch image layers, store them here
			canvasWidth: 100,			// Default width, replaced by imageContainer width
			canvasHeight: 100
		}
	},
	watch: {
		value() {
			this.selected = this.value

			if (!this.layers)
				this.fetchImageLayers()
		},
		imageUrl() {
			this.fetchImageLayers()
		},
		selected() {
			this.$emit("selectChange",this.selected)
		},
	},
	computed: {
		uploadedAt() {
			if (this.fileRecord && 'created_at' in this.fileRecord && this.fileRecord.created_at)
				return this.formatDateTimeToLocal(this.fileRecord.created_at)
			return false
		},
		uploadedBy() {
			if (this.fileRecord && 'UpdatedBy' in this.fileRecord && this.fileRecord.UpdatedBy) {
				const tokens = []
				if ('first_name' in this.fileRecord.UpdatedBy && this.fileRecord.UpdatedBy.first_name)
					tokens.push(this.fileRecord.UpdatedBy.first_name)
				if ('last_name' in this.fileRecord.UpdatedBy && this.fileRecord.UpdatedBy.last_name)
					tokens.push(this.fileRecord.UpdatedBy.last_name)
				return tokens.join(" ")
			}

			return false
		},
		fileRecord() {
			if (this.value) {
				if ('UploadImage' in this.value && this.value.UploadImage)
					return this.value.UploadImage
				else if ('UploadFile' in this.value && this.value.UploadFile)
					return this.value.UploadFile
			}
			return false
		},
		isPdf() {
			if (!this.imageUrl)
				return false
			else if (this.forcePdf)
				return true

			let split = this.imageUrl.split("?")

			split = split[0].split(".")

			if (split[split.length - 1].toLowerCase() == 'pdf')
				return true
			else
				return false
		},
		localExpandUrl() {
			if (this.expandUrl)
				return this.expandUrl
			else
				return this.imageUrl
		},
		downloadUrl() {
			//strips the query params
			if (this.localExpandUrl) {
				let split = this.localExpandUrl.split("?")

				return split[0]+"?download=true"
			}
			else
				return ""
		}
	},
	methods: {
		imageEdited(newLayer) {
			this.$emit("editedImg",newLayer)
			this.editingVisible = false
		},
		rotateImage(dir) {
			this.$emit("rotate",dir)
		},
		deleteImg() {
			this.$emit("deleteImg")
		},
		saveLayer(newLayer) {
			let vm = this

			let payload = {
				layer_json: JSON.stringify(newLayer)
			}

			if (this.imageUrl)
				payload.image_id = this.value.id
			else
				payload.canvas_id = this.value.id

			this.postData("ImageDrawLayer/save", payload).then(response => {
				if (response.success) {
					vm.alertSaved('Image has successfully been saved.')

					// Refetch layers
					vm.fetchImageLayers()
				}
			})
		},
		deleteLayer(layerId) {
			let vm = this

			this.postData("ImageDrawLayer/delete",{id: layerId}).then(response => {
				if (response.success) {
					vm.fetchImageLayers()
				}
			})
		},
		imageClicked() {
			if (this.expandOnClick)
				this.viewerVisible = true
			else if (this.selectable) {
				this.selected = !this.selected
			}
			else
				this.$emit("open",this.expandUrl)
		},
		fetchImageLayers() {
			let vm = this

			// No image id supplied? We cant fetch the layers.... skip
			if (!this.value || !('id' in this.value) || !this.value.id)
				return

			let params = {
				filters: []
			}

			//check if we're authenticated
			if ("userDetails" in this.$store && this.$store.userDetails && "id" in this.$store.userDetails) {
				// If no imageURL is provided, we assume it is a blank canvas layer
				if (this.imageUrl)
					params.filters.push(['image_id', this.value.id])
				else
					params.filters.push(['canvas_id', this.value.id])
			}
			else {
				// If no imageURL is provided, we assume it is a blank canvas layer
				if (this.imageUrl)
					params = {
						image_id: this.value.id
					}
				else {
					params = {
						canvas_id: this.value.id
					}
				}
			}
			

			this.getJSON("ImageDrawLayer/get", params).then(response => {
				if (response.success)
					vm.layers = response.data

			})
		}

	},

	mounted() {

		if ("imageContainer" in this.$refs && this.$refs.imageContainer)
			this.canvasWidth = this.$refs.imageContainer.offsetWidth

		if (this.value && 'height' in this.value && 'width' in this.value) {
			let hwRatio = this.value.height / this.value.width
			this.canvasWidth = this.value.width
			this.canvasHeight = this.canvasWidth * hwRatio
		} else {
			this.canvasHeight = null
		}
	},

	created() {
		this.fetchImageLayers()
	}
}
</script>

<style type="text/css" scoped>
	.image-panel {
		position: relative;
		text-align: center;
	}

	.image-panel img:hover {
		cursor: pointer
	}

	.image-panel .banner {
		position: absolute;
		right: 0;
		width: 100%;
		background-color: rgba(0,0,0,0.5);
		padding: 4px;
		text-align: right;
		z-index: 5;
		display: none;
	}

	.image-panel .banner-top {
		top: 0;
	}

	.image-panel .banner-bottom {
		color: white;
		bottom: 0;
	}

	.image-panel:hover .banner {
		display: block;
	}

	.image-panel img {
		max-height: 100%;
		max-width: 100%;
	}

	.select-checkbox {
		position: absolute;
		top: 8px;
		left: 8px;
		height: 17px;
		width: 17px;
	}

	.pdf-container {
		position: relative;
	}

	.pdf-btn-container {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0.8);
		padding: 4px;
		text-align: right;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		display: none;
	}

	.pdf-container:hover .pdf-btn-container {
		display: flex;
	}

	.pdf-btn-container i {
		margin: 10px;
		font-size: 22pt;
	}

	iframe {
		width: 100%;
	}

</style>